import USER_ROLE from 'constants/role';

const PERMISSION_LABELS = Object.freeze({
  [USER_ROLE.manager]: 'common.permissionRoles.manager',
  [USER_ROLE.receptionist]: 'common.permissionRoles.receptionist',
  [USER_ROLE.noAccess]: 'common.permissionRoles.noAccess',
});

export default PERMISSION_LABELS;
